/**
 * Avatar Display State
 * NgRx state interface for avatar display functionality.
 */

import { AvatarRecord } from '../types/avatar-types';

/**
 * Avatar display state key.
 */
export const avatarDisplayKey = 'avatarDisplay';

/**
 * Avatar display state interface.
 */
export interface AvatarDisplayState {
  /**
   * Avatar status information.
   */
  status: {
    processing: AvatarRecord | null;
    current: AvatarRecord | null;
    lastFailed: AvatarRecord | null;
  };

  /**
   * Current avatar image information.
   */
  image: {
    imageUrl: string | null;
    isDefault: boolean;
    width?: number;
    height?: number;
  };

  /**
   * Loading states.
   */
  loading: {
    fetchingStatus: boolean;
    fetchingImage: boolean;
  };

  /**
   * Error message (if any).
   */
  error: string | null;
}

/**
 * Initial state.
 */
export const initialAvatarDisplayState: AvatarDisplayState = {
  status: {
    processing: null,
    current: null,
    lastFailed: null
  },
  image: {
    imageUrl: null,
    isDefault: false,
    width: undefined,
    height: undefined
  },
  loading: {
    fetchingStatus: false,
    fetchingImage: false
  },
  error: null
};
